module.exports = __webpack_public_path__ + "img/container.4ad61251.svg";